<div class="max-w-screen-xl p-6 mx-auto shadow-lg animate-slide-in-left bg-white/80backdrop-blur-md rounded-xl">


  <app-datatable [data]="badges" [columns]="columns" dataType="Gestion des Cartes d'Inspection"
    boutonDataType="Carte d'inspection" routeNavigate="badge/ajout" [currentPage]="currentPage"
    [totalPages]="totalPages" [totalElements]="totalItems" (pageChange)="onPageChange($event)"></app-datatable>
</div>
